import { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';

export function filterVenuesBySearchTearm(
  venues: Venue<string>[],
  searchTerm: string,
  getExtraSearchableText?: (venue: Venue<string>) => string
): Venue<string>[] {
  if (!searchTerm) {
    return venues;
  }
  const cleanedSearchTerm = searchTerm.trim().toLowerCase();

  return venues.filter(venue => {
    const coordinates = venue.latlng ? `${venue.latlng.lat}, ${venue.latlng.lng}` : '';
    const extraSearchableText = getExtraSearchableText ? getExtraSearchableText(venue) : '';
    const venueSearchableText =
      `${venue.postalCode || ''}${venue.name || ''}${venue.address || ''}${coordinates}${extraSearchableText}`.toLowerCase();
    return venueSearchableText.includes(cleanedSearchTerm);
  });
}
